import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    bgImage = [
        {
            img: 'assets/img/register-shape.jpg'
        }
    ]

    submit(form){
        var name = form.name;
        console.log(name);

        var email = form.email;
        console.log(email);

        var subject = form.subject;
        console.log(subject);

        var message = form.message;
        console.log(message);
    }

}
